<template>
  <section class="chi-card">
    <h2 v-if="title" class="page-title">
      {{ title }}
    </h2>
    <div
      class="w-full max-w-4xl m-auto overflow-hidden shadow-lg bg-white mb-4 rounded-b-lg rounded-t"
    >
      <div :class="[className ? `${className}` : 'p-12']">
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ChiCard",
  props: ["title", "className"],
};
</script>

<style scoped>
.chi-card {
  @apply max-w-4xl;
  @apply m-auto;
}

/* typo */
.page-title {
  color: #555;
  @apply font-normal;
  @apply text-left;
  @apply capitalize;
  @apply mb-5;
}
</style>
